import Vuex from 'vuex';
import { createHelpers } from 'vuex-map-fields';

Vue.use(Vuex);
const { getFieldLlammadas, updateFieldLlamadas } = createHelpers({
  getterType: 'getFieldLlammadas',
  mutationType: 'updateFieldLlamadas',
});

export default {
  namespaced: true,
  state: {
    agendadas: [],
  },
  getters: {
    getFieldLlammadas,
  },
  mutations: {
    updateFieldLlamadas,
  },
};
